import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

// Import global CSS variables and shared components (must be first)
import './styles/_variables.css';
import './styles/_components.css';

// Import Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-perfect-scrollbar/dist/css/styles.css';

// Import Gogo template theme (includes main.scss with all variables defined)
import './css/sass/themes/gogo.light.purplemonster.scss';

// Import custom WebRTC styles
import './assets/css/webrtc-custom.css';

// Accessibility baseline (focus-visible ring + reduced-motion) — loaded last so
// it wins the cascade over the scattered `outline: none` rules.
import './styles/_a11y.css';

// Import App
import App from './App';
import configureStore from './redux/store';

// Initialize the app
const store = configureStore();

// Expose store for DevBridge introspection in dev mode only.
if (import.meta.env.DEV) {
  window.__REDUX_STORE__ = store;
  import('./dev/dev-bridge-client.js').then(({ startDevBridgeClient }) => startDevBridgeClient());
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>
);
